var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolMoreMenu = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 6",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4.5-11.5h29v29h-29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M2.75.583A2.424 2.424 0 0 0 .333 3 2.424 2.424 0 0 0 2.75 5.417 2.424 2.424 0 0 0 5.167 3 2.424 2.424 0 0 0 2.75.583m14.5 0A2.424 2.424 0 0 0 14.833 3a2.424 2.424 0 0 0 2.417 2.417A2.424 2.424 0 0 0 19.667 3 2.424 2.424 0 0 0 17.25.583m-7.25 0A2.424 2.424 0 0 0 7.583 3 2.424 2.424 0 0 0 10 5.417 2.424 2.424 0 0 0 12.417 3 2.424 2.424 0 0 0 10 .583"
}))));
export { SvgToolMoreMenu as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-more-menu.svg";